import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

const PROD_HOSTS = new Set(["trainingbasket.in", "www.trainingbasket.in"]);

export function isProdHost() {
  return PROD_HOSTS.has(window.location.hostname.toLowerCase());
}

export function Hard404() {
  useEffect(() => {
    try { window.parent.postMessage({ type: "tb-devroute-404" }, window.location.origin); } catch (e) {}
  }, []);
  return <div data-testid="dev-route-404" aria-hidden="true" />;
}

export function ProdBlocked({ children }) {
  return isProdHost() ? <Hard404 /> : children;
}

export function StaffGated({ children }) {
  const [allowed, setAllowed] = useState(null);
  useEffect(() => {
    let live = true;
    api.get("/auth/me")
      .then((r) => {
        if (!live) return;
        const u = r.data;
        const staff = u && (u.role === "admin" || u.is_super_admin || u.role === "counselor" || u.role_id || (u.custom_permissions && Object.keys(u.custom_permissions).length > 0));
        setAllowed(Boolean(staff));
      })
      .catch(() => { if (live) setAllowed(false); });
    return () => { live = false; };
  }, []);
  if (allowed === null) {
    return <div className="min-h-screen bg-white flex items-center justify-center" data-testid="staff-gate-loading"><Loader2 className="w-6 h-6 animate-spin text-slate-300" /></div>;
  }
  return allowed ? children : <Hard404 />;
}
